import { css } from "@emotion/css";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
const maxWideDrawerWidth = "1220px";
const maxMediumDrawerWidth = "975px";
const maxNarrowDrawerWidth = "730px";
export const drawerContainerStyles = css({
    // Using `&` twice to increase specificity
    "&&": {
        backgroundColor: themeTokens.color.background.primary.default,
        width: "90%",
        overflowY: "visible",
        color: themeTokens.color.text.primary,
    },
});
export const drawerModalStyles = css({
    // Using `&` twice to increase specificity
    "&&": {
        zIndex: "auto",
        isolation: "isolate",
    },
});
export const wideContainerStyles = css({
    maxWidth: maxWideDrawerWidth,
});
export const mediumContainerStyles = css({
    maxWidth: maxMediumDrawerWidth,
});
export const narrowContainerStyles = css({
    maxWidth: maxNarrowDrawerWidth,
});
export const outerDrawerHeaderStyles = css({
    padding: space["16"],
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "row",
    gap: space["8"],
});
export const innerDrawerHeaderStyles = css({
    width: "100%",
    height: "100%",
    display: "grid",
    gridTemplateColumns: "1FR auto",
});
export const iconContainer = css({
    margin: "5px",
});
export const drawerTitleStyles = css({
    font: text.heading.large,
    margin: 0,
    gridRow: 1,
    gridColumn: 1,
});
export const drawerSubtitleTitleStyles = css({
    color: themeTokens.color.text.secondary,
    font: text.body.regular.large,
    gridRow: 2,
    gridColumn: 1,
    margin: 0,
});
export const drawerContentStyles = css({
    overflow: "auto",
    flexGrow: "1",
});
export const drawerActionListStyles = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    gap: space["16"],
    gridRow: 1,
    gridColumn: 2,
});
